import {createApi} from '@reduxjs/toolkit/query/react';

import {
	LogisticListRequestType,
	ResponseLogisticListType,
	DeleteLogisticOrder,
} from '../../types/TypesDepotLogistic';
import {customAxiosBaseQuery} from '../../API/customAxiosBaseQuery';
import {storeLogisticAPI} from '../../API/api';

export const depotLogisticApi = createApi({
	reducerPath: 'logisticApi',
	baseQuery: customAxiosBaseQuery,
	tagTypes: ['LogisticList'],
	endpoints: (builder) => ({
		getLogisticList: builder.query<
			ResponseLogisticListType,
			LogisticListRequestType
		>({
			query: (props) => ({
				func: storeLogisticAPI.getStoreList,
				args: [props],
			}),
			providesTags: ['LogisticList'],
		}),
		deleteLogisticOrder: builder.mutation<void, DeleteLogisticOrder>({
			query: (props) => ({
				func: storeLogisticAPI.getDeleteOrder,
				args: [props],
			}),
			invalidatesTags: ['LogisticList'],
		}),
		acceptProcessedOrder: builder.mutation<void, number>({
			query: (props) => ({
				func: storeLogisticAPI.getAcceptProcessingOrder,
				args: [props],
			}),
			invalidatesTags: ['LogisticList'],
		}),
		approvePayOrder: builder.mutation<void, number>({
			query: (props) => ({
				func: storeLogisticAPI.getApprovePaidOrder,
				args: [props],
			}),
			invalidatesTags: ['LogisticList'],
		}),
		shipOrder: builder.mutation<void, number>({
			query: (props) => ({
				func: storeLogisticAPI.getShipOrder,
				args: [props],
			}),
			invalidatesTags: ['LogisticList'],
		}),
	}),
});

export const {
	useGetLogisticListQuery,
	useDeleteLogisticOrderMutation,
	useAcceptProcessedOrderMutation,
	useApprovePayOrderMutation,
	useShipOrderMutation,
} = depotLogisticApi;
